jQuery.noConflict();
jQuery(document).ready(function($) {

  let select_ID = 0;
  $('select.soff_image_select').each(function(){
    //Create fake select and options containers
      $(this).after('<div id ="soff_image_select_placeholder_' + select_ID + '" class="soff_image_select_placeholder" data-toggle="dropdown" data-target="soff_image_select_dropdown_' + select_ID + '"><img src="' + $(this).find('option:selected').data('img-thumbnail') + '"><span class="soff_image_select_placeholder_text">' + $(this).find('option:selected').text() + '</span></div><div id ="soff_image_select_dropdown_' + select_ID + '" class="soff_image_select_dropdown soff_dropdown" data-select-id="' + $(this).attr('id') + '" data-select-placeholder-id="soff_image_select_placeholder_' + select_ID + '"></div>');

    //Populate options
    $(this).find('option').each(function(){
      let classes = "soff_image_select_option_placeholder"
      if ($(this).is(':selected')){
        classes += " selected";
      }
        $('#soff_image_select_dropdown_' + select_ID).append('<div class="' + classes + '" data-value="' + $(this).val()+ '"><img src="' + $(this).data('img-thumbnail') + '"><div class="soff_image_select_option_placeholder_text">' + $(this).text() + '</div></div>');
    })
    select_ID++;
  });

  //Select option from dropdown
  $('.soff_image_select_option_placeholder').click(function(){
    let selectId = '#' + $(this).closest('.soff_image_select_dropdown').data('select-id');
    let selectPlaceholderId = '#' + $(this).closest('.soff_image_select_dropdown').data('select-placeholder-id');
    let newValue = $(this).data('value');
    let newImage = $(this).find('img').attr('src');
    let newText = $(this).find('.soff_image_select_option_placeholder_text').text();
    $(selectPlaceholderId).find('.soff_image_select_placeholder_text').text(newText);
    $(selectPlaceholderId).find('img').attr('src', newImage);
    $(selectId).val(newValue).change();
  });

  $('.soff_image_select_option_placeholder').mouseenter(function(){
    $(this).closest('.soff_image_select_dropdown').find('.soff_image_select_option_placeholder.selected').removeClass('selected');
    $(this).addClass('selected');
  });
});
